import React from 'react'
import FailedTerminationFileView from '../components/FailedTerminationFileViewer'

const FailedTerminationFilePage = (
  props: Record<string, never> & { routeParams: { importPublicKey: string } }
) => {
  return (
    <div>
      <FailedTerminationFileView {...props} routeParams={props.routeParams} />
    </div>
  )
}

export default FailedTerminationFilePage
